import React, { useId } from 'react';
import { beeInner } from './beeSvg';
import './bees.css';

/**
 * One bee (see beeSvg.js). `size` in px; `title` makes it an image with a name for screen
 * readers, else it is decoration. Motion follows the state and stops for people who asked
 * the system for less motion; `still` keeps a resting bee still (rows of avatars), so only
 * bees that are doing something move. `tight` crops the room kept for the marks around
 * the bee, for avatars that should fill their spot.
 */
const Bee = ({ species, color, state, accessory, size = 64, title, still = false, tight = false, className = '', style }) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  const inner = beeInner({ species, color, state, accessory, uid });
  const shown = state || 'idle';
  return (
    <svg
      viewBox={tight ? '9 9 102 102' : '0 0 120 120'} width={size} height={size}
      className={`bb-bee bb-bee--${shown}${still ? ' bb-bee--still' : ''} ${className}`}
      style={{ overflow: 'visible', display: 'block', flex: 'none', ...style }}
      role={title ? 'img' : undefined} aria-label={title || undefined} aria-hidden={title ? undefined : true}
      // SVG text built from our own geometry; the only outside input, the color, is checked there.
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
};

export default Bee;
